import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Defensive guard for API responses that are expected to be arrays.
 *
 * Many list endpoints return a bare JSON array on success (e.g. `[ ... ]`)
 * but switch to an error object on failure (e.g. `{ error: "Unauthorized" }`).
 * Feeding the error object straight into `.map`, `.filter`, or `<Select>` will
 * crash the page with `x.map is not a function`.
 *
 * Use this helper anywhere a value coming from an API or untrusted source is
 * about to be iterated as an array:
 *
 *   const agents = asArray<Agent>(await api("/crm/agents"));
 *   setAgents(asArray(a));
 */
export function asArray<T = unknown>(value: unknown): T[] {
  return Array.isArray(value) ? (value as T[]) : [];
}
